import { OnboardingAudit, PersonFundRequestStatus, PICKER_LEAD_ID_STORAGE_KEY } from '@ipensii/shared/domain-shared';
import { AbstractJsonApiService } from './abstract-json-api.service';
import { Observable, tap } from 'rxjs';
import { inject } from '@angular/core';
import { CacheService } from '../cache.service';
import { ObjectUtils } from '@ipensii/shared/util-shared';

export class OnboardingRequestService extends AbstractJsonApiService<PersonFundRequestStatus> {
  private readonly cacheService = inject(CacheService);

  constructor() {
    super('onboarding');
  }

  getOngoingRequestOrCreateForUserFund({ fundId }: { fundId: string }): Observable<PersonFundRequestStatus> {
    const leadId = this.cacheService.getItem(PICKER_LEAD_ID_STORAGE_KEY);
    const params = ObjectUtils.toFilteredQueryParams({ leadId });
    const url = params ? `fund/${fundId}?${params}` : `fund/${fundId}`;

    return this.get(url).pipe(tap(() => this.cacheService.removeItem(PICKER_LEAD_ID_STORAGE_KEY)));
  }

  startAdminSigning({ requestId, password }: { requestId: string; password: string }): Observable<void> {
    return this.post(`${requestId}/admin/startSigning`, password);
  }

  signAdminDocument({ requestId, otp }: { requestId: string; otp: string }): Observable<PersonFundRequestStatus> {
    return this.post(`${requestId}/admin/sign`, otp);
  }

  completeRequest({ requestId }: { requestId: string }): Observable<PersonFundRequestStatus> {
    return this.put(`${requestId}/admin/complete`);
  }

  rejectRequest({ requestId }: { requestId: string }): Observable<PersonFundRequestStatus> {
    return this.put(`${requestId}/admin/reject`);
  }

  resetRequest({ requestId }: { requestId: string }): Observable<PersonFundRequestStatus> {
    return this.put(`${requestId}/reset`);
  }

  renewIdentificationSession({ requestId }: { requestId: string }): Observable<PersonFundRequestStatus> {
    return this.put(`${requestId}/renewIdentification`);
  }

  resetDocument({ requestId }: { requestId: string }): Observable<PersonFundRequestStatus> {
    return this.put(`${requestId}/reset`);
  }

  startIdentification({ requestId }: { requestId: string }): Observable<PersonFundRequestStatus> {
    return this.put(`${requestId}/startIdentification`);
  }

  getPdf({ requestId }: { requestId: string }): Observable<string> {
    return this.get(`${requestId}/pdf`);
  }

  startSigning({ requestId }: { requestId: string }): Observable<void> {
    return this.post(`${requestId}/startSigning`);
  }

  signDocument({ requestId, otp }: { requestId: string; otp: string }): Observable<PersonFundRequestStatus> {
    return this.post(`${requestId}/sign`, otp);
  }

  getRequestAuditDetails({ requestId }: { requestId: string }): Observable<OnboardingAudit> {
    return this.get(`${requestId}/admin/audit`);
  }
}
